import React from 'react';

const organizationContent = {
  'def': {
    name: 'Dansk EL-Forbund',
    logo: '/images/DEF.png',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til Dansk EL-Forbund</h2>
        <div class="bg-blue-50 border-l-4 border-blue-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            Som medlem af Dansk El-Forbund kan du nemt få adgang til alle offentlige overenskomster, aftaler og lønninger i Faglig Håndbog.
          </p>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  '3f': {
    name: '3F',
    logo: '/images/3F_LOGO_Den_Offentlige_Gruppe.png',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til 3F Faglig Håndbog</h2>
        <div class="bg-green-50 border-l-4 border-green-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            Som medlem af 3F Den Offentlige Gruppe (Kommunale/Regionale/Staten) kan du nemt få adgang til alle gruppens overenskomster, aftaler og lønninger i Faglig Håndbog
          </p>
        </div>
        <div class="grid md:grid-cols-3 gap-6">
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Ansat i en kommune</h3>
            <a href="/org/3f/folder/1507" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Overenskomster</span>
            </a>
            <a href="/org/3f/folder/1480" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Lønninger</span>
            </a>
            <a href="/org/3f/folder/1668" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Oversigt over lønbilag</span>
            </a>
            <a href="/org/3f/folder/1341" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Generelle regler og aftaler</span>
            </a>
            <a href="/org/3f/folder/6119" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Reguleringsprocent</span>
            </a>
          </div>
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Ansat i en regionerne</h3>
            <a href="/org/3f/folder/1796" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Overenskomster</span>
            </a>
            <a href="/org/3f/folder/1774" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Lønninger</span>
            </a>
            <a href="/org/3f/folder/6411" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Oversigt over lønbilag</span>
            </a>
            <a href="/org/3f/folder/1672" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Generelle regler og aftaler</span>
            </a>
            <a href="/org/3f/folder/6409" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Reguleringsprocent</span>
            </a>
          </div>
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Ansat i staten</h3>
            <a href="/org/3f/folder/2033" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Organisationsaftaler og overenskomster</span>
            </a>
            <a href="/org/3f/folder/1933" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Lønninger</span>
            </a>
            <a href="/org/3f/folder/2020" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Oversigt over lønbilag</span>
            </a>
            <a href="/org/3f/folder/1883" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Generelle regler og aftaler</span>
            </a>
            <a href="/org/3f/folder/6410" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Reguleringsprocent</span>
            </a>
          </div>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  'tl': {
    name: 'Teknisk Landsforbund',
    logo: '/images/TekniskLandsforbund.svg',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til TL’s Faglige Håndbog</h2>
        <div class="bg-purple-50 border-l-4 border-purple-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            I den faglige håndbog finder du overenskomster og aftaler.
          </p>
        </div>
        <div class="grid md:grid-cols-2 gap-6">
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Kommune, region og stat</h3>
             <a href="/org/tl/folder/5837" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Kommunale overenskomster</span>
            </a>
             <a href="/org/tl/folder/5998" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Regionale overenskomster</span>
            </a>
             <a href="/org/tl/folder/6050" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Statslige overenskomster</span>
            </a>
          </div>
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Privat og Teater</h3>
             <a href="/org/tl/folder/5902" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Private overenskomster</span>
            </a>
             <a href="/org/tl/folder/6094" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Teater overenskomster</span>
            </a>
          </div>
        </div>
        <div class="mt-6">
            <div class="bg-white p-4 rounded-lg shadow">
              <h3 class="text-xl font-semibold text-gray-800 mb-2">Nyttige links</h3>
              <a href="https://www.forhandlingsfaellesskabet.dk/lontabeller/satsfinder/beregner" target="_blank" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Satsfinderen</span>
              </a>
              <a href="https://cirkulaere.medst.dk/love-regler-og-aftaler/beregner-2012/" target="_blank" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Grundbeløbsberegneren</span>
              </a>
            </div>
          </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  'dm': {
    name: 'Dansk Metal',
    logo: '/images/DanskMetal.png',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til Dansk Metal</h2>
        <div class="bg-red-50 border-l-4 border-red-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            I Faglig Håndbog finder du alle de overenskomster, aftaler, love, vejledninger og andet, som er gældende for OAO’s forbunds medlemmer, der ansat i kommuner og regioner.
          </p>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  'hk': {
    name: 'HK Kommunal',
    logo: '/images/HKKommunal.png',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til Faglig Håndbog</h2>
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            I Faglig Håndbog finder du de oplysninger, som angår DIG og DIT ansættelsesforhold.
          </p>
          <p class="text-gray-600">
            Du kan finde dokumenter enten ved at anvende ”Emner” indgangen, ved brug af søgefunktionen og ved direkte link til nedenstående hovedemner.
          </p>
        </div>
        <div class="grid md:grid-cols-2 gap-6">
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Overenskomster</h3>
            <p class="text-gray-600 mb-4">Her findes samtlige centrale overenskomster og aftaler, som du har brug for - fordelt på kommuner (KL) og regioner (RLTN).</p>
            <a href="/org/hk/folder/4229" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Gå til Overenskomster</span>
            </a>
          </div>
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">Generelle løn- og ansættelsesvilkår</h3>
            <p class="text-gray-600 mb-4">De generelle regler og aftaler om arbejdstid, lønberegning, pension, seniorpolitik ferie, barsel, TR-vilkår m.m. er medtaget, så du altid kan finde de oplysninger, du skal bruge.</p>
            <a href="/org/hk/folder/4198" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Gå til Løn- og ansættelsesvilkår</span>
            </a>
          </div>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  'ds': {
    name: 'Dansk Socialrådgiverforening',
    logo: '/images/DS.png',
    content: `
      <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til Dansk Socialrådgiverforenings Faglige Håndbog</h2>
        <div class="bg-indigo-50 border-l-4 border-indigo-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            I den faglige håndbog finder du alle de overenskomster, aftaler, love, vejledninger og andet, som er gældende for DS' medlemmer ansat i kommuner, regioner og stat. Du kan finde aftaler om løn, ferie, barsel, senior og meget mere.
          </p>
          <p class="text-gray-600">
            Har du behov for at se aftaler for andre organisationer, kan du klikke på logoet i toppen af siden, og derefter vælge den relevante organisation.
          </p>
        </div>
        <div class="grid md:grid-cols-2 gap-6">
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">For dig som er ansat i en kommune</h3>
            <a href="/org/ds/folder/3566" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Find din overenskomst</span>
            </a>
            <a href="/org/ds/folder/3391" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Aftaler om barsel og ferie</span>
            </a>
            <a href="/org/ds/folder/3427" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Andre dokumenter og aftaler</span>
            </a>
          </div>
          <div class="bg-white p-4 rounded-lg shadow">
            <h3 class="text-xl font-semibold text-gray-800 mb-2">For dig som er ansat i en region</h3>
             <a href="/org/ds/folder/3577" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Find din overenskomst</span>
            </a>
            <a href="/org/ds/folder/3401" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Aftaler om barsel og ferie</span>
            </a>
            <a href="/org/ds/folder/3445" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
                <span class="text-orange-500">›</span>
                <span>Andre dokumenter og aftaler</span>
            </a>
          </div>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg text-center">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
      </div>
    `
  },
  'sl': {
    name: 'Socialpædagogerne',
    logo: '/images/Socialpaedagogerne.svg',
    content: `
       <div class="organization-content">
        <h2 class="text-3xl font-bold text-gray-800 mb-6">Velkommen til Socialpædagogernes Faglig Håndbog</h2>
        <div class="bg-indigo-50 border-l-4 border-indigo-400 p-6 mb-6">
          <p class="text-lg text-gray-700 mb-4">
            I den faglige håndbog finder du alle de overenskomster, aftaler, love, vejledninger og andet, som er gældende for Socialpædagogernes medlemmer ansat i kommuner og regioner.
          </p>
          <p class="text-gray-600">
            Du kan finde aftaler om arbejdstid, løn, ferie, barsel, senior og meget mere.
          </p>
        </div>
        <div class="grid md:grid-cols-2 gap-6">
             <div class="bg-white p-4 rounded-lg shadow">
          <h3 class="text-xl font-semibold text-gray-800 mb-3">For dig som er ansat i en kommune</h3>
          <div class="flex flex-col gap-2">
            <a href="/org/sl/folder/5611" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Find din overenskomst</span>
            </a>
            <a href="/org/sl/folder/5456" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Aftaler om arbejdstid</span>
            </a>
            <a href="/org/sl/folder/5438" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Andre dokumenter og aftaler</span>
            </a>
          </div>
        </div>
        <div class="bg-white p-4 rounded-lg shadow">
          <h3 class="text-xl font-semibold text-gray-800 mb-3">For dig som er ansat i en region</h3>
          <div class="flex flex-col gap-2">
            <a href="/org/sl/folder/5805" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Find din overenskomst</span>
            </a>
            <a href="/org/sl/folder/5762" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Aftaler om arbejdstid</span>
            </a>
            <a href="/org/sl/folder/5747" class="flex items-center gap-2 text-gray-700 hover:text-orange-600 transition-colors no-underline">
              <span class="text-orange-500">›</span>
              <span>Andre dokumenter og aftaler</span>
            </a>
          </div>
        </div>
      </div>
      <div class="max-w-xl mx-auto mt-8 p-4 bg-gray-100 rounded-lg">
        <p class="text-sm text-gray-600">
          Brug menuen til venstre for at navigere i Faglig Håndbog.
        </p>
        <p class="text-sm text-gray-600">
          Hvis du har brug for hjælp, er du altid velkommen til at kontakte <a class="hover:text-orange-600 font-bold" href="mailto:webmaster@sl.dk">Socialpædagogerne</a>.
        </p>
      </div>
    `
  }
};

const OrganizationFrontPage = ({ organizationKey }) => {
  const organization = organizationContent[organizationKey];

  if (!organization) {
    return (
      <div className="flex-1 p-6 flex items-center justify-center text-gray-500">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Organisation ikke fundet</h2>
          <p>Den angivne organisation kunne ikke findes.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 p-6 max-w-6xl mx-auto w-full">
      {/* Organization Logo */}
      <div className="mb-8 flex justify-center">
        <img 
          src={organization.logo} 
          alt={`${organization.name} Logo`} 
          className="h-32 object-contain"
          style={{ maxWidth: '400px' }}
        />
      </div>

      {/* Custom HTML Content */}
      <div 
        className="w-full"
        dangerouslySetInnerHTML={{ __html: organization.content }}
      />
    </div>
  );
};

export default OrganizationFrontPage;